<template>
    <!-- This component handles both script and noscript parts -->
    <!-- The noscript part will be rendered in the body -->
</template>

<script>
export default {
    name: 'GTMLoader',
    props: {
        gtmId: {
            type: String,
            required: true,
            validator: value => /^GTM-[A-Z0-9]{4,8}$/i.test(value)
        },
        dataLayerName: {
            type: String,
            default: 'dataLayer'
        }
    },
    watch: {
        gtmId(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.cleanupGTM();
                this.injectGTM();
                this.injectNoscript();
            }
        }
    },
    mounted() {
        this.injectGTM();
        this.injectNoscript();
    },
    beforeDestroy() {
        this.cleanupGTM();
    },
    methods: {
        injectGTM() {
            if (document.getElementById(`gtm-script-${this.gtmId}`)) {
                return; // Avoid duplicate loading
            }

            const scriptContent = `
                (function(w,d,s,l,i){
                    w[l]=w[l]||[];
                    w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
                    var f=d.getElementsByTagName(s)[0],
                    j=d.createElement(s),
                    dl=l!='dataLayer'?'&l='+l:'';
                    j.async=true;
                    j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
                    f.parentNode.insertBefore(j,f);
                })(window,document,'script','${this.dataLayerName}','${this.gtmId}');
            `;

            const gtmScript = document.createElement('script');
            gtmScript.id = `gtm-script-${this.gtmId}`;
            gtmScript.innerHTML = scriptContent;
            document.head.insertBefore(gtmScript, document.head.firstChild);
        },

        injectNoscript() {
            // Remove existing noscript if any
            this.removeNoscript();

            const noscript = document.createElement('noscript');
            const iframe = document.createElement('iframe');
            iframe.src = `https://www.googletagmanager.com/ns.html?id=${this.gtmId}`;
            iframe.height = '0';
            iframe.width = '0';
            iframe.style.display = 'none';
            iframe.style.visibility = 'hidden';

            noscript.appendChild(iframe);
            document.body.insertBefore(noscript, document.body.firstChild);
        },

        removeNoscript() {
            const existingNoscript = document.querySelector('noscript > iframe[src^="https://www.googletagmanager.com/ns.html"]');
            if (existingNoscript && existingNoscript.parentNode) {
                existingNoscript.parentNode.remove();
            }
        },

        cleanupGTM() {
            // Remove GTM script
            const existingScript = document.getElementById(`gtm-script-${this.gtmId}`);
            if (existingScript) {
                existingScript.remove();
            }

            // Remove noscript iframe
            this.removeNoscript();
        }
    }
};
</script>




// WEBPACK FOOTER //
// src/components/GTMLoader.vue